var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorLoginRedirect2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 392 287.59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.45 233.05 124.27 54.54L392 191.78l-126.08-38.73-190.47 80z",
    fill: "#7a7a7a",
    className: "fill-fbbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.95 235.14 0 175.87l81.35-33.01 196.59 81.94-72.21 31.24M246.55 205.52 117.6 146.25l70.74-26.97 150.76 56.59-41.56 22.55",
    fill: "#bdbdbd",
    opacity: 0.15,
    className: "fill-020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.94 224.8 212.06 198l-.88-117.18 64.98 16.35 1.78 127.63z",
    fill: "#bfbfbf",
    className: "fill-e2000f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.94 224.8 61.01-28.3-.89-117.89-61.9 18.56 1.78 127.63z",
    fill: "#2b2b2b",
    className: "fill-139334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.06 78.61-61.9 18.56-64.98-16.35 60.89-18.92 65.99 16.71z",
    fill: "#7a7a7a",
    className: "fill-fbbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.82 261.93-65.87-26.79-.89-216.22 64.98 16.36 1.78 226.65z",
    fill: "#2b2b2b",
    className: "fill-139334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.82 261.93 61.01-28.29-.88-216.93-61.91 18.57 1.78 226.65z",
    fill: "#ff002b",
    className: "fill-0094da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.95 16.71-61.91 18.57-64.98-16.36L188.96 0l65.99 16.71z",
    fill: "#bfbfbf",
    className: "fill-e2000f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.06 200.95 12.44-5.76-.18-24.04-12.62 3.79.36 26.01zM231.87 193.88l12.44-5.77-.18-24.03-12.62 3.79.36 26.01zM231.87 63.61l12.44-5.77-.18-24.03-12.62 3.78.36 26.02zM208.88 105.46l12.44-5.77-.18-24.03-12.62 3.78.36 26.02zM230.1 130.22l12.44-5.77-.18-24.03-12.62 3.78.36 26.02zM290.23 134.93l12.44-5.77-.18-24.03-12.62 3.79.36 26.01zM314.05 164.83l12.43-5.77-.18-24.03-12.61 3.79.36 26.01z",
    fill: "#ffffff",
    className: "fill-ffffff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLoginRedirect2);
export default __webpack_public_path__ + "static/media/ErrorLoginRedirect2.a2239a98741f7bfb19a2f9ac924c1e61.svg";
export { ForwardRef as ReactComponent };